<style lang="scss" src="./App.scss"></style>
<script lang="ts" src="./App.ts"></script>

<template>
  <HandleCache ref="cacheBuster">
    <template v-slot="{ isLoading, isLatestVersionAvailable }">
      <q-linear-progress dark rounded indeterminate color="warning" v-if="isLoading" />
      <template v-else-if="isLatestVersionAvailable">
        <FeatureFlagProvider :ld-context="ldContext">
          <SignalR v-if="isAuthenticated && !is401" />
          <MediaDeviceNotSupported />
          <q-layout>
            <HeaderComponent v-if="isAuthenticated && !is401" />
            <Drawer v-if="isAuthenticated && !is401" />
            <q-page-container>
              <q-linear-progress dark rounded indeterminate color="warning" v-if="profileLoading" />
              <router-view v-else :key="$route.fullPath" />
            </q-page-container>
          </q-layout>
          <div class="drawing" id="loading" v-if="loadingSpinner">
            <q-linear-progress dark rounded indeterminate color="warning" />
          </div>
          <transition name="cookie-banner">
            <CookiesBanner
              v-if="isCookiesBannerVisible"
              @accept-all="acceptAllCookies"
              @accept-essential="acceptEssentialCookies"
              @navigate-settings="navigateCookieSettings"
            />
          </transition>
        </FeatureFlagProvider>
      </template>
      <template v-else>
        {{ cacheBuster.clearCacheAndReload() }}
      </template>
    </template>
  </HandleCache>
</template>
